'use client';

import React from 'react';
import { ChevronLeft } from 'lucide-react';

interface Props {
  selected: string[];
  onChange: (goals: string[]) => void;
  onNext: () => void;
  onBack: () => void;
}

const GOALS = [
  { id: 'talk', emoji: '💬', label: 'Someone to talk to' },
  { id: 'understand', emoji: '🪞', label: 'Understand my emotions' },
  { id: 'stress', emoji: '🌿', label: 'Manage stress' },
  { id: 'relationships', emoji: '💞', label: 'Improve relationships' },
  { id: 'habits', emoji: '✨', label: 'Build better habits' },
  { id: 'explore', emoji: '🌱', label: 'Just exploring' },
];

export default function StepGoals({ selected, onChange, onNext, onBack }: Props) {
  const toggle = (id: string) => {
    if (selected.includes(id)) {
      onChange(selected.filter((s) => s !== id));
    } else {
      onChange([...selected, id]);
    }
  };

  return (
    <div className="flex-1 flex flex-col px-6 py-8 max-w-sm mx-auto w-full slide-up">
      <button
        onClick={onBack}
        className="flex items-center gap-1 text-muted-foreground text-sm mb-8 hover:text-foreground transition-colors"
      >
        <ChevronLeft size={18} />
        Back
      </button>

      <div className="flex-1 flex flex-col gap-6">
        <div>
          <h2 className="text-2xl font-bold text-foreground leading-snug">
            What brings you here?
          </h2>
          <p className="text-sm text-muted-foreground mt-2">Choose everything that feels right.</p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {GOALS.map((goal) => {
            const isSelected = selected.includes(goal.id);
            return (
              <button
                key={`goal-${goal.id}`}
                onClick={() => toggle(goal.id)}
                className={`onboarding-chip flex items-center gap-2 text-left ${
                  isSelected ? 'selected' : ''
                }`}
              >
                <span className="text-xl">{goal.emoji}</span>
                <span className="text-sm font-medium leading-tight">{goal.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      <div className="pt-6">
        <button
          onClick={onNext}
          disabled={selected.length === 0}
          className="w-full py-4 rounded-2xl lavender-gradient text-white font-semibold text-base shadow-card transition-all duration-200 active:scale-95 disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Continue
        </button>
        <button
          onClick={onNext}
          className="w-full py-3 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          Skip for now
        </button>
      </div>
    </div>
  );
}